// removed by extract-text-webpack-plugin
module.exports = {"newsletter":"newsletter--3ovHH calderLC--1nri-","visuallyhidden":"visuallyhidden--1di10","submit":"submit--3N0mO"};


//////////////////
// WEBPACK FOOTER
// ./components/NewsletterForm/styles.css
// module id = 983
// module chunks = 2